"use strict";

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
	return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
	return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

Object.defineProperty(exports, "__esModule", {
	value: true
});

var Misc = {
	$_GET: function $_GET() {
		var url = window.document.location.href.toString();
		var u = url.split("?");
		if (typeof u[1] == "string") {
			u = u[1].split("&");
			var get = {};
			for (var i in u) {
				var j = u[i].split("=");
				get[j[0]] = j[1];
			}
			return get;
		} else {
			return {};
		}
	},
	clone: function clone(obj) {
		if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) != 'object' | obj === null) return obj;
		var re = {};
		if (obj.constructor == Array) re = [];
		for (var i in obj) {
			re[i] = Misc.clone(obj[i]);
		}
		return re;
	},
	tempVar: function tempVar(k, v) {
		window.mimironUse.tempVar = window.mimironUse.tempVar || {};
		if (typeof v == "undefined") {
			return window.mimironUse.tempVar[k];
		} else {
			window.mimironUse.tempVar[k] = v;
		}
		return;
	},
	inList: function inList(item, list) {
		var flag = false;
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = list[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var ins = _step.value;

				if (item == ins) {
					flag = true;
					break;
				}
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator["return"]) {
					_iterator["return"]();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}

		return flag;
	},
	harmoniousDivision: function harmoniousDivision(sum, cnt) {
		var resp = [];
		var tempSum = 0;
		var aver = Number((sum / cnt).toFixed(2));
		while (cnt--) {
			resp.push(cnt ? aver : Number((sum - tempSum).toFixed(2)));
			tempSum += aver;
		}
		return resp;
	},
	padZero: function padZero(num, n) {
		var len = num.toString().length;
		while (len < n) {
			num = "0" + num;
			len++;
		}
		return num;
	},
	ts2str: function ts2str(ts) {
		if (ts) {
			var dt = new Date();
			dt.setTime(ts * 1000);
			return dt.toLocaleString();
		}
	},
	date2str: function date2str(d, format) {
		d = d || new Date();
		format = format || "YYYY-MM-DD";
		var year = d.getFullYear();
		var month = this.padZero(d.getMonth() + 1, 2);
		var day = this.padZero(d.getDate(), 2);
		return format.replace("YYYY", year).replace("yyyy", year).replace("%Y", year).replace("MM", month).replace("mm", month).replace("%m", month).replace("DD", day).replace("dd", day).replace("%D", day);
	},
	formatMoney: function formatMoney(number, places, symbol, thousand, decimal) {
		places = !isNaN(places = Math.abs(places)) ? places : 2;
		symbol = symbol !== undefined ? symbol : "￥";
		thousand = thousand || ",";
		decimal = decimal || ".";
		number = Number(number);
		var negative = number < 0 ? "-" : "",
		    i = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + "",
		    j = (j = i.length) > 3 ? j % 3 : 0;
		return symbol + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : "");
	},
	uuid: function uuid() {
		var s = [];
		var hexDigits = "0123456789abcdef";
		for (var i = 0; i < 36; i++) {
			s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
		}
		s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
		s[19] = hexDigits.substr(s[19] & 0x3 | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
		s[8] = s[13] = s[18] = s[23] = "-";

		var uuid = s.join("");
		return uuid;
	},
	getUrlParam: function getUrlParam(index) {
		if (index === undefined) {
			index = -1;
		}
		var hash = window.location.hash.split("/");
		return hash[hash.length + Number(index)];
	}
};

exports["default"] = Misc;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/tools/misc.js
 ** module id = 623
 ** module chunks = 0
 **/